import { render, staticRenderFns } from "./SortGroupList.vue?vue&type=template&id=a847c9c0"
import script from "./SortGroupList.vue?vue&type=script&lang=ts"
export * from "./SortGroupList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports